import React, { useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Select, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createReview } from "../../../../api/reviews";
const { TextArea } = Input;

const CreateReview: React.FC = () => {
  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: createReview,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
      setOpen(false);
    },
  });

  const onSubmit = async () => {
    const { rating, content } = await form.validateFields();
    const data = { rating: Number(rating), content, user_id: 1, product_id: 1 };
    mutate({ data });
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>+</Button>
      <Modal
        title="Create Review"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="back" onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            form="createReview"
            htmlType="submit"
            onSubmit={onSubmit}
            loading={isLoading}
            className="border-0 bg-blue-600 text-white"
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          id="createReview"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="rating"
                label="Rating"
                rules={[
                  {
                    required: true,
                    message: "Please enter rating",
                  },
                ]}
              >
                <Input placeholder="Rating" />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="content"
                label="Remarks"
                rules={[
                  {
                    required: false,
                    message: "Please enter remarks",
                  },
                ]}
              >
                <TextArea placeholder="Remarks" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default CreateReview;
